export default function getDocsBaseUrl() {
  // let version = '4.5';
  // const licenseType = config?.license_info?.license_type;

  // if (licenseType && licenseType !== 'open' && config?.version) {
  //   version = parseFloat(config?.version.split('-')[0]).toFixed(1);
  // }
  return `https://docs.ascender-automation.org`;
}
